import { PublicPurchaseService } from './purchase';
import { PublicPurchaseServiceV2 } from './purchase.v2';
export function createPublicPurchaseService(httpClient) {
    return new PublicPurchaseServiceV2(httpClient);
}
export { PublicPurchaseService };
//# sourceMappingURL=index.js.map